import { observer } from 'mobx-react-lite'

import { useCollaborationDialog } from './CollaborationDialogStore'

import { ReactComponent as ChevronDownIcon } from 'assets/icons/chevronDown16.svg'
import { ReactComponent as ChevronUpIcon } from 'assets/icons/chevronUp16.svg'
import { Button } from 'components/Button'

export const CollaborationDialogChevron = observer(function CollaborationDialogChevron() {
  const collaborationDialogStore = useCollaborationDialog()
  const Icon = collaborationDialogStore.fullScreen ? ChevronDownIcon : ChevronUpIcon
  return (
    <Button
      preventFocusOnPress
      frontIcon={Icon}
      onClick={(e) => {
        e.stopPropagation()
        collaborationDialogStore.toggleFullscreen()
      }}
      variant="none"
      size="lg"
    />
  )
})
